import { createApp } from 'vue';
import JpgToPdfConverter from '@/Components/JpgToPdfConverter.vue';
import '@styles/app.css';

createApp(JpgToPdfConverter).mount('#jpg-to-pdf-converter');
